import React, { useCallback } from 'react';
import { Button, PasswordInput, TextInput, Unform } from 'components';
import { loginValidationSchema } from 'yupSchemas/login';
import { Box, Flex, Link } from '@chakra-ui/react';
import { setItemStorage } from 'services/storage';
import { postLogin, verificantionLogin } from 'services/auth';
import { RouteComponentProps } from 'react-router';
import { ILoginData } from 'types/auth';
import { authenticatedKey, rolesKey, tokenKey, userKey } from 'constants/storage';
import { openNotification } from 'utils/notification';
import logoDaniel from '../assets/logo-daniel.svg';

import pkg from '../../../../package.json';

import { ImgLogo as Image } from './styles';
import * as Styles from './styles';

import { colors } from 'theme/colors';
import { format, add } from 'date-fns';

export const Login: React.FC<RouteComponentProps> = ({ history }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleLogin = useCallback(async (formData: ILoginData) => {
    try {
      setIsLoading(true);

      const { data } = await postLogin(formData);

      setItemStorage(authenticatedKey, 'true');
      setItemStorage(tokenKey, data.access_token);
      setItemStorage(userKey, {
        id: data.id,
        name: data.name,
        email: data.email,
        admin: data.admin,
        enableHoursBank: data.enableHoursBank,
        client: data.client || '',
        clientName: data.clientName || '',
        isParticipant: !!(
          data.roles.length === 1 && data.roles[0]?.authority === 'ROLE_GESTAO_PARTICIPANTE'
        ),
      });
      setItemStorage(rolesKey, data.roles);
      openNotification(
        `Sua sessão expira às ${format(add(Date.now(), { seconds: data.expires_in }), 'HH:mm')}`,
        'warn',
      );
      if (data.roles.length === 1 && data.roles[0]?.authority === 'ROLE_GESTAO_PARTICIPANTE')
        history.push('/clientDemands');
      else history.push('/home');
    } catch (error: any) {
      await verificantionLogin(formData);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <Flex height="100vh" alignItems="center" justifyContent="center">
      <Flex direction="column" p={12} alignItems="center" justifyContent="center">
        <Flex
          width="400px"
          alignItems="center"
          direction="column"
          background="#fff"
          p={8}
          paddingTop={'4'}
          rounded={6}
          border={'1px solid #E9EBEE'}
          boxShadow={'0px 4px 20px rgba(0,0,0,0.20);'}
        >
          <Image src={logoDaniel} alt="Logo DPO Hub" mb={-1} />
          <Unform validationSchema={loginValidationSchema} onSubmit={handleLogin}>
            <TextInput
              height={'50px'}
              label="Usuário"
              color="brand.900"
              name="userName"
              background="#fff"
              border={'1px solid #CCD1D6 !important'}
            />
            <PasswordInput
              height={'50px'}
              label="Senha"
              color="brand.900"
              background="#fff"
              name="password"
              border={'1px solid #CCD1D6 !important'}
              placeholder="******"
            />
            <Button type="submit" isLoading={isLoading} fullWidth>
              Entrar
            </Button>
            <Styles.Span>
              Esqueceu a senha? &nbsp;
              <Link href="/forgetPassword" color={'#7E225A'} fontWeight={700}>
                Clique aqui!
              </Link>
            </Styles.Span>
          </Unform>
          <Box fontSize="13px" fontWeight="bold" color={colors.brand[500]}>
            {pkg.version} {process.env.REACT_APP_BUILD_NUMBER}
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};
